import React from "react";
import { ExtractGroup } from "../../../types/extract.types";
import { MeterIcon, LampIcon } from "../icons";
import styles from "./DeviceTypeSectionView.module.scss";

export interface DeviceTypeSectionViewProps {
  groups: ExtractGroup[] | undefined;
  isLoading: boolean;
  selectedGroupId: string | null;
  onGroupSelect: (group: ExtractGroup) => void;
}

function resolveGroupIcon(group: ExtractGroup, active: boolean) {
  const name = group.name.toLowerCase();
  const type = (group.deviceType ?? "").toLowerCase();
  const isMeter =
    name.includes("compteur") ||
    name.includes("meter") ||
    type.includes("meter") ||
    type.includes("compteur");
  return isMeter ? <MeterIcon active={active} /> : <LampIcon active={active} />;
}

export default function DeviceTypeSectionView({
  groups,
  isLoading,
  selectedGroupId,
  onGroupSelect,
}: DeviceTypeSectionViewProps) {
  return (
    <div className={styles["device-type"]}>
      <div className={styles["device-type__header"]}>
        <span className={styles["device-type__badge"]}>1</span>
        <h2 className={styles["device-type__title"]}>Type de device</h2>
      </div>

      <div className={styles["device-type__groups"]}>
        {isLoading && (
          <p className={styles["device-type__placeholder"]}>Chargement...</p>
        )}

        {groups?.map((group) => {
          const isActive = selectedGroupId === group.id;
          return (
            <div
              key={group.id}
              className={`${styles["device-type__card"]} ${
                isActive ? styles["device-type__card--active"] : ""
              }`}
              onClick={() => onGroupSelect(group)}
            >
              <div className={styles["device-type__card-info"]}>
                <h3>{group.name}</h3>
                <p>{group.description}</p>
                <span className={styles["device-type__card-count"]}>
                  {group.extracts.length} extrait
                  {group.extracts.length > 1 ? "s" : ""} disponible
                  {group.extracts.length > 1 ? "s" : ""}
                </span>
              </div>
              <div className={styles["device-type__card-icon"]}>
                {resolveGroupIcon(group, isActive)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
